"use client";
import { FilterOptions } from "@/context/SearchContext";
import { qualitySystemName } from "./quality-score-entry";

export interface FilterDropdownOptionsProps {
  id: string;
  filterKey: keyof FilterOptions;
  options: string[];
  sections?: string[];
  selectedValues: string[];
  onOptionChange: (key: keyof FilterOptions, value: string) => void;
  getDisplayName: (key: keyof FilterOptions, value: string) => string;
}

export function FilterDropdownOptions({
  id,
  filterKey,
  options,
  sections,
  selectedValues,
  onOptionChange,
  getDisplayName,
}: FilterDropdownOptionsProps) {
  const renderOption = (option: string, prefix = "") => (
    <div className="selectOption" key={`${prefix}${option}`}>
      <input
        type="checkbox"
        id={`${id}-${prefix}${option}`}
        name={id}
        value={option}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onOptionChange(filterKey, option);
          }
        }}
        onChange={() => onOptionChange(filterKey, option)}
        checked={selectedValues.includes(option)}
      />
      <label htmlFor={`${id}-${prefix}${option}`}>
        {getDisplayName(filterKey, option)}
      </label>
    </div>
  );

  if (Array.isArray(sections) && sections.length > 1) {
    return (
      <>
        {sections.map((section) => (
          <div key={section} className="quality-filter-section">
            <div className="quality-filter-section-label">
              {qualitySystemName(section)}
            </div>
            {options
              .filter((opt) => opt.startsWith(`${section}:`))
              .map((option) => renderOption(option, `${section}-`))}
          </div>
        ))}
      </>
    );
  }

  return <>{options.map((option) => renderOption(option))}</>;
}
